import { Routes, Route, Navigate } from 'react-router-dom';

import { Loader } from '../../components/Loader';

import { Checkout } from '../../Checkout/Checkout';
import { Help } from '../../views/Help';
import { Menu } from '../../Menu/Menu';
import { Order } from '../../Order';
import { Product } from '../../Product';
import { Account } from '../../Account/index';
import { Search } from '../../Menu/Search';
import OAuth from '../../Auth/OAuth';
import { useAppSelector } from '../../reduxstore/hooks';
import { MobileCart } from '../../Cart/MobileCart';
import { Scan } from '../../Account/views/Scan/Scan';
import { Outer } from './Outer';
import { AccessibilityIcon } from '../../Footer/components/AccessibilityIcon';

export const Router: React.FC = () => {
	const userId = useAppSelector(state => state.authReducer.id);
	return (
		<Loader title="WebLayout/Router">
			<Routes>
				<Route element={<Outer />}>
					{!userId && (
						<>
							<Route path="/login/" element={<OAuth />} />
							<Route path="/login/*" element={<OAuth />} />
						</>
					)}
					<Route path="/account/*" element={<Account />} />
					<Route path="/scan" element={<Scan />} />
					<Route path="/cart" element={<MobileCart />} />
					<Route
						path="/orders/*"
						element={
							<Loader title="/orders/*">
								<Order />
							</Loader>
						}
					/>
					<Route
						path="/checkout/*"
						element={
							<Loader title="/checkout/*">
								<Checkout />
							</Loader>
						}
					/>
					<Route
						path="/help"
						element={
							<Loader title="/help">
								<Help />
							</Loader>
						}
					/>

					<Route
						path="/menu/*"
						element={
							<Loader title="/menu/*">
								<Menu />
							</Loader>
						}
					/>
					<Route
						path="/search/*"
						element={
							<Loader title="/search/*">
								<Search />
							</Loader>
						}
					/>
					<Route
						path="/product/*"
						element={
							<Loader title="/product/*">
								<Product />
							</Loader>
						}
					/>
					<Route
						path="/accessibility-statement"
						element={<AccessibilityIcon />}
					/>
					<Route path="/" element={<Navigate to="/menu" replace />} />
					<Route path="*" element={<Navigate to="/menu" replace />} />
				</Route>
			</Routes>
		</Loader>
	);
};
